'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _Reflect$construct = require('@babel/runtime-corejs3/core-js-stable/reflect/construct');
var _possibleConstructorReturn = require('@babel/runtime-corejs3/helpers/possibleConstructorReturn');
var _getPrototypeOf = require('@babel/runtime-corejs3/helpers/getPrototypeOf');
var _inherits = require('@babel/runtime-corejs3/helpers/inherits');
var _createClass = require('@babel/runtime-corejs3/helpers/createClass');
var _classCallCheck = require('@babel/runtime-corejs3/helpers/classCallCheck');
var _defineProperty = require('@babel/runtime-corejs3/helpers/defineProperty');
var _concatInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/concat');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _Reflect$construct__default = /*#__PURE__*/_interopDefaultLegacy(_Reflect$construct);
var _possibleConstructorReturn__default = /*#__PURE__*/_interopDefaultLegacy(_possibleConstructorReturn);
var _getPrototypeOf__default = /*#__PURE__*/_interopDefaultLegacy(_getPrototypeOf);
var _inherits__default = /*#__PURE__*/_interopDefaultLegacy(_inherits);
var _createClass__default = /*#__PURE__*/_interopDefaultLegacy(_createClass);
var _classCallCheck__default = /*#__PURE__*/_interopDefaultLegacy(_classCallCheck);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var _concatInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_concatInstanceProperty);

function _callSuper(t, o, e) { return o = _getPrototypeOf__default["default"](o), _possibleConstructorReturn__default["default"](t, _isNativeReflectConstruct() ? _Reflect$construct__default["default"](o, e || [], _getPrototypeOf__default["default"](t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(_Reflect$construct__default["default"](Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
// ========================= File parsing =========================

/**
 * File format.
 *
 * @export
 * @enum {string}
 */
var FileFormat = /*#__PURE__*/function (FileFormat) {
  FileFormat["None"] = "none";
  FileFormat["ZIP"] = "zip";
  FileFormat["GZIP"] = "gzip";
  FileFormat["TAR"] = "tar";
  return FileFormat;
}({});

/**
 * File parsing options.
 * - format:
 * - parsing configurations.
 *
 * @export
 * @interface ParsingOptions
 */

/**
 * Tabular data parsing options.
 * - separator: field separator of one row
 * - eol: end of line char
 * - header: 'true' | 'false', whether the 1st row is header
 * - quote?: separator / eol within matched quote char will be ignored
 *
 * @export
 * @interface TabularParsingOptions
 * @extends {ParsingOptions}
 */

/**
 * JSON data parsing options.
 * - eol: end of line char
 *
 * @export
 * @interface JSONParsingOptions
 * @extends {ParsingOptions}
 */
/**
 * data parser base class with default values
 */
var DataParser = /*#__PURE__*/_createClass__default["default"](function DataParser() {
  _classCallCheck__default["default"](this, DataParser);
  _defineProperty__default["default"](this, "format", FileFormat.None);
  _defineProperty__default["default"](this, "eol", '\\n');
});
/**
 * CSV parser with default value.
 *
 * @export
 * @class TabularParser
 */
var TabularParser = /*#__PURE__*/function (_DataParser2) {
  function TabularParser() {
    var _context;
    var _this;
    _classCallCheck__default["default"](this, TabularParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, TabularParser, _concatInstanceProperty__default["default"](_context = []).call(_context, args));
    _defineProperty__default["default"](_this, "separator", ',');
    _defineProperty__default["default"](_this, "header", true);
    _defineProperty__default["default"](_this, "quote", '');
    _defineProperty__default["default"](_this, "json", false);
    return _this;
  }
  _inherits__default["default"](TabularParser, _DataParser2);
  return _createClass__default["default"](TabularParser);
}(DataParser);

/**
 * JSON parser with default value.
 *
 * @export
 * @class JSONParser
 */
var JSONParser = /*#__PURE__*/function (_DataParser3) {
  function JSONParser() {
    var _context2;
    var _this2;
    _classCallCheck__default["default"](this, JSONParser);
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    _this2 = _callSuper(this, JSONParser, _concatInstanceProperty__default["default"](_context2 = []).call(_context2, args));
    _defineProperty__default["default"](_this2, "json", true);
    return _this2;
  }
  _inherits__default["default"](JSONParser, _DataParser3);
  return _createClass__default["default"](JSONParser);
}(DataParser);

// ========================= Data format =========================

/**
 * Data format.
 *
 * @export
 * @enum {string}
 */
var DataFormat = /*#__PURE__*/function (DataFormat) {
  DataFormat["None"] = "none";
  DataFormat["CSV"] = "csv";
  DataFormat["TSV"] = "tsv";
  DataFormat["JSON"] = "json";
  return DataFormat;
}({}); // TODO: Support more data formats in the future.
// AVRO = 'avro',
// PARQUET = 'parquet',

// ========================= Data schema =========================

/**
 * Tabular data type.
 *
 * @export
 * @enum {string}
 */
var TabularDataType = /*#__PURE__*/function (TabularDataType) {
  TabularDataType["String"] = "string";
  return TabularDataType;
}({});

/**
 * JSON data type.
 *
 * @export
 * @enum {string}
 */
var JSONDataType = /*#__PURE__*/function (JSONDataType) {
  JSONDataType["Null"] = "null";
  JSONDataType["String"] = "string";
  JSONDataType["Number"] = "number";
  JSONDataType["Integer"] = "integer";
  JSONDataType["Boolean"] = "boolean";
  JSONDataType["Object"] = "object";
  JSONDataType["Array"] = "array";
  return JSONDataType;
}({});

/**
 * The schema of a data field.
 *
 * @export
 * @interface DataFieldSchema
 */

/**
 * The tabular schema of a data field.
 * - type: its data type.
 *
 * @export
 * @interface TabularDataFieldSchema
 * @extends DataFieldSchema
 */

/**
 * The flattened JSON schema of a data field.
 * - type: its data type.
 * - level: its number of level in the JSON schema of the data set.
 * - path: the path from its ancester to itself in the JSON schema of the data set.
 *
 * @export
 * @interface JSONDataFieldSchema
 * @extends DataFieldSchema
 */

// ========================= File info =========================

/**
 * File info.
 *
 * @export
 * @interface FileInfo
 */

// ========================= Data set =========================

/**
 * Data set.
 *
 * @export
 * @interface DataSet
 */

exports.DataFormat = DataFormat;
exports.FileFormat = FileFormat;
exports.JSONDataType = JSONDataType;
exports.JSONParser = JSONParser;
exports.TabularDataType = TabularDataType;
exports.TabularParser = TabularParser;
